module.exports = __webpack_public_path__ + "media/blackAndWhite.ad088471.mp4";